import { useMediaQuery } from "usehooks-ts"

export function DesktopOnly({ children }: { children: React.ReactNode }) {
  const isDesktop = useMediaQuery("(min-width: 769px)")

  return isDesktop ? children : null
}
